<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="about">
    <h2>{{ t('common.about') }}</h2>
    <p>{{ t('common.info') }}</p>
  </div>
</template>

<style scoped>
.about {
  text-align: center;
  padding: 2rem;
}

.about h2 {
  color: #42b883;
  margin-bottom: 1rem;
}

.about p {
  color: #666;
  font-size: 1.2rem;
}
</style>
